export const THEMES = {
  default: {
    name: 'Default',
    nameAr: 'افتراضي',
    nameEn: 'Default',
    bg: '#f8fafc',
    card: '#ffffff',
    sidebar: '#f1f5f9',
    hover: '#e2e8f0',
    input: '#ffffff',
    text: '#0f172a',
    textSecondary: '#475569',
    textMuted: '#546070',
    border: '#e2e8f0',
    borderStrong: '#cbd5e1',
    accent: '#4f46e5',
    accentLight: '#e0e7ff',
    accentHover: '#4338ca',
    image: null,
    imageOverlay: 'rgba(255,255,255,0.72)',
    cardOverlay: 'rgba(255,255,255,0.85)',
    sidebarOverlay: 'rgba(255,255,255,0.60)',
    modalOverlay: 'rgba(255,255,255,0.88)',
    chatTransparentOverlay: 'rgba(255,255,255,0.38)',
    cardTransparentOverlay: 'rgba(255,255,255,0.42)',
    sidebarTransparentOverlay: 'rgba(255,255,255,0.30)',
    modalTransparentOverlay: 'rgba(255,255,255,0.55)',
    inputTransparentOverlay: 'rgba(255,255,255,0.45)',
    footerTransparentOverlay: 'rgba(255,255,255,0.25)',
    connectionPillTransparentOverlay: 'rgba(255,255,255,0.35)',
  },
  midnight: {
    name: 'Minuit',
    nameAr: 'منتصف الليل',
    nameEn: 'Midnight',
    bg: '#0f172a',
    card: 'rgba(30,41,59,0.92)',
    sidebar: 'rgba(15,23,42,0.95)',
    hover: 'rgba(51,65,85,0.6)',
    input: 'rgba(30,41,59,0.8)',
    text: '#f1f5f9',
    textSecondary: '#cbd5e1',
    textMuted: '#94a3b8',
    border: 'rgba(148,163,184,0.2)',
    borderStrong: 'rgba(148,163,184,0.3)',
    accent: '#818cf8',
    accentLight: 'rgba(129,140,248,0.15)',
    accentHover: '#a5b4fc',
    image: 'url(https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?w=1920&q=80)',
    imageOverlay: 'rgba(15,23,42,0.88)',
    cardOverlay: 'rgba(30,41,59,0.90)',
    sidebarOverlay: 'rgba(15,23,42,0.85)',
    modalOverlay: 'rgba(15,23,42,0.92)',
    chatTransparentOverlay: 'rgba(15,23,42,0.65)',
    cardTransparentOverlay: 'rgba(30,41,59,0.72)',
    sidebarTransparentOverlay: 'rgba(15,23,42,0.60)',
    modalTransparentOverlay: 'rgba(15,23,42,0.78)',
    inputTransparentOverlay: 'rgba(30,41,59,0.65)',
    footerTransparentOverlay: 'rgba(15,23,42,0.45)',
    connectionPillTransparentOverlay: 'rgba(15,23,42,0.55)',
  },
  nature: {
    name: 'Nature',
    nameAr: 'طبيعة',
    nameEn: 'Nature',
    bg: '#f0fdf4',
    card: 'rgba(255,255,255,0.90)',
    sidebar: 'rgba(240,253,244,0.92)',
    hover: 'rgba(187,247,208,0.5)',
    input: 'rgba(255,255,255,0.85)',
    text: '#14532d',
    textSecondary: '#166534',
    textMuted: '#15803d',
    border: 'rgba(21,128,61,0.15)',
    borderStrong: 'rgba(21,128,61,0.25)',
    accent: '#15803d',
    accentLight: 'rgba(22,163,74,0.12)',
    accentHover: '#166534',
    image: 'url(https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1920&q=80)',
    imageOverlay: 'rgba(255,255,255,0.72)',
    cardOverlay: 'rgba(255,255,255,0.85)',
    sidebarOverlay: 'rgba(255,255,255,0.60)',
    modalOverlay: 'rgba(255,255,255,0.88)',
    chatTransparentOverlay: 'rgba(255,255,255,0.38)',
    cardTransparentOverlay: 'rgba(255,255,255,0.42)',
    sidebarTransparentOverlay: 'rgba(255,255,255,0.30)',
    modalTransparentOverlay: 'rgba(255,255,255,0.55)',
    inputTransparentOverlay: 'rgba(255,255,255,0.45)',
    footerTransparentOverlay: 'rgba(255,255,255,0.25)',
    connectionPillTransparentOverlay: 'rgba(255,255,255,0.35)',
  },
  ocean: {
    name: 'Océan',
    nameAr: 'محيط',
    nameEn: 'Ocean',
    bg: '#f0f9ff',
    card: 'rgba(255,255,255,0.90)',
    sidebar: 'rgba(240,249,255,0.92)',
    hover: 'rgba(186,230,253,0.5)',
    input: 'rgba(255,255,255,0.85)',
    text: '#0c4a6e',
    textSecondary: '#075985',
    textMuted: '#0369a1',
    border: 'rgba(3,105,161,0.15)',
    borderStrong: 'rgba(3,105,161,0.25)',
    accent: '#0369a1',
    accentLight: 'rgba(2,132,199,0.12)',
    accentHover: '#075985',
    image: 'url(https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=1920&q=80)',
    imageOverlay: 'rgba(255,255,255,0.72)',
    cardOverlay: 'rgba(255,255,255,0.85)',
    sidebarOverlay: 'rgba(255,255,255,0.60)',
    modalOverlay: 'rgba(255,255,255,0.88)',
    chatTransparentOverlay: 'rgba(255,255,255,0.38)',
    cardTransparentOverlay: 'rgba(255,255,255,0.42)',
    sidebarTransparentOverlay: 'rgba(255,255,255,0.30)',
    modalTransparentOverlay: 'rgba(255,255,255,0.55)',
    inputTransparentOverlay: 'rgba(255,255,255,0.45)',
    footerTransparentOverlay: 'rgba(255,255,255,0.25)',
    connectionPillTransparentOverlay: 'rgba(255,255,255,0.35)',
  },
  sunset: {
    name: 'Crépuscule',
    nameAr: 'غروب',
    nameEn: 'Sunset',
    bg: '#fff7ed',
    card: 'rgba(255,255,255,0.90)',
    sidebar: 'rgba(255,247,237,0.92)',
    hover: 'rgba(254,215,170,0.5)',
    input: 'rgba(255,255,255,0.85)',
    text: '#7c2d12',
    textSecondary: '#9a3412',
    textMuted: '#c2410c',
    border: 'rgba(194,65,12,0.15)',
    borderStrong: 'rgba(194,65,12,0.25)',
    accent: '#c2410c',
    accentLight: 'rgba(234,88,12,0.12)',
    accentHover: '#9a3412',
    image: 'url(https://images.unsplash.com/photo-1495616811223-4d98c6e9c869?w=1920&q=80)',
    imageOverlay: 'rgba(255,255,255,0.72)',
    cardOverlay: 'rgba(255,255,255,0.85)',
    sidebarOverlay: 'rgba(255,255,255,0.60)',
    modalOverlay: 'rgba(255,255,255,0.88)',
    chatTransparentOverlay: 'rgba(255,255,255,0.38)',
    cardTransparentOverlay: 'rgba(255,255,255,0.42)',
    sidebarTransparentOverlay: 'rgba(255,255,255,0.30)',
    modalTransparentOverlay: 'rgba(255,255,255,0.55)',
    inputTransparentOverlay: 'rgba(255,255,255,0.45)',
    footerTransparentOverlay: 'rgba(255,255,255,0.25)',
    connectionPillTransparentOverlay: 'rgba(255,255,255,0.35)',
  },
  // New accessible themes
  charcoal: {
    name: 'Charbon',
    nameAr: 'فحم',
    nameEn: 'Charcoal',
    bg: '#18181b',
    card: 'rgba(39,39,42,0.92)',
    sidebar: 'rgba(24,24,27,0.95)',
    hover: 'rgba(63,63,70,0.6)',
    input: 'rgba(39,39,42,0.8)',
    text: '#fafafa',
    textSecondary: '#e4e4e7',
    textMuted: '#a1a1aa',
    border: 'rgba(161,161,170,0.2)',
    borderStrong: 'rgba(161,161,170,0.3)',
    accent: '#38bdf8',
    accentLight: 'rgba(56,189,248,0.15)',
    accentHover: '#7dd3fc',
    image: null,
    imageOverlay: 'rgba(24,24,27,0.88)',
    cardOverlay: 'rgba(39,39,42,0.90)',
    sidebarOverlay: 'rgba(24,24,27,0.85)',
    modalOverlay: 'rgba(24,24,27,0.92)',
    chatTransparentOverlay: 'rgba(24,24,27,0.65)',
    cardTransparentOverlay: 'rgba(39,39,42,0.72)',
    sidebarTransparentOverlay: 'rgba(24,24,27,0.60)',
    modalTransparentOverlay: 'rgba(24,24,27,0.78)',
    inputTransparentOverlay: 'rgba(39,39,42,0.65)',
    footerTransparentOverlay: 'rgba(24,24,27,0.45)',
    connectionPillTransparentOverlay: 'rgba(24,24,27,0.55)',
  },
  lavender: {
    name: 'Lavande',
    nameAr: 'خزامى',
    nameEn: 'Lavender',
    bg: '#faf5ff',
    card: 'rgba(255,255,255,0.90)',
    sidebar: 'rgba(250,245,255,0.92)',
    hover: 'rgba(233,213,255,0.5)',
    input: 'rgba(255,255,255,0.85)',
    text: '#581c87',
    textSecondary: '#7e22ce',
    textMuted: '#9333ea',
    border: 'rgba(126,34,206,0.15)',
    borderStrong: 'rgba(126,34,206,0.25)',
    accent: '#7e22ce',
    accentLight: 'rgba(168,85,247,0.12)',
    accentHover: '#6b21a8',
    image: null,
    imageOverlay: 'rgba(255,255,255,0.72)',
    cardOverlay: 'rgba(255,255,255,0.85)',
    sidebarOverlay: 'rgba(255,255,255,0.60)',
    modalOverlay: 'rgba(255,255,255,0.88)',
    chatTransparentOverlay: 'rgba(255,255,255,0.38)',
    cardTransparentOverlay: 'rgba(255,255,255,0.42)',
    sidebarTransparentOverlay: 'rgba(255,255,255,0.30)',
    modalTransparentOverlay: 'rgba(255,255,255,0.55)',
    inputTransparentOverlay: 'rgba(255,255,255,0.45)',
    footerTransparentOverlay: 'rgba(255,255,255,0.25)',
    connectionPillTransparentOverlay: 'rgba(255,255,255,0.35)',
  },
  coffee: {
    name: 'Café',
    nameAr: 'قهوة',
    nameEn: 'Coffee',
    bg: '#fafaf9',
    card: 'rgba(255,255,255,0.90)',
    sidebar: 'rgba(250,250,249,0.92)',
    hover: 'rgba(231,229,228,0.5)',
    input: 'rgba(255,255,255,0.85)',
    text: '#451a03',
    textSecondary: '#78350f',
    textMuted: '#92400e',
    border: 'rgba(120,53,15,0.15)',
    borderStrong: 'rgba(120,53,15,0.25)',
    accent: '#92400e',
    accentLight: 'rgba(180,83,9,0.12)',
    accentHover: '#78350f',
    image: null,
    imageOverlay: 'rgba(255,255,255,0.72)',
    cardOverlay: 'rgba(255,255,255,0.85)',
    sidebarOverlay: 'rgba(255,255,255,0.60)',
    modalOverlay: 'rgba(255,255,255,0.88)',
    chatTransparentOverlay: 'rgba(255,255,255,0.38)',
    cardTransparentOverlay: 'rgba(255,255,255,0.42)',
    sidebarTransparentOverlay: 'rgba(255,255,255,0.30)',
    modalTransparentOverlay: 'rgba(255,255,255,0.55)',
    inputTransparentOverlay: 'rgba(255,255,255,0.45)',
    footerTransparentOverlay: 'rgba(255,255,255,0.25)',
    connectionPillTransparentOverlay: 'rgba(255,255,255,0.35)',
  },
};

export function applyTheme(themeKey) {
  const t = THEMES[themeKey] || THEMES.default;
  const root = document.documentElement;
  root.setAttribute('data-theme', themeKey);
  root.style.setProperty('--bg', t.bg);
  root.style.setProperty('--bg-card', t.card);
  root.style.setProperty('--bg-sidebar', t.sidebar);
  root.style.setProperty('--bg-hover', t.hover);
  root.style.setProperty('--bg-input', t.input);
  root.style.setProperty('--text', t.text);
  root.style.setProperty('--text-secondary', t.textSecondary);
  root.style.setProperty('--text-muted', t.textMuted);
  root.style.setProperty('--border', t.border);
  root.style.setProperty('--border-strong', t.borderStrong);
  root.style.setProperty('--accent', t.accent);
  root.style.setProperty('--accent-light', t.accentLight);
  root.style.setProperty('--accent-hover', t.accentHover);

  // Theme-aware image overlays so dark themes don't get white-on-white
  root.style.setProperty('--bg-image-overlay', t.imageOverlay || 'rgba(255,255,255,0.72)');
  root.style.setProperty('--bg-card-image-overlay', t.cardOverlay || 'rgba(255,255,255,0.78)');
  root.style.setProperty('--bg-sidebar-image-overlay', t.sidebarOverlay || 'rgba(255,255,255,0.60)');
  root.style.setProperty('--bg-modal-image-overlay', t.modalOverlay || 'rgba(255,255,255,0.85)');
  root.style.setProperty('--bg-chat-transparent-overlay', t.chatTransparentOverlay || 'rgba(255,255,255,0.38)');
  root.style.setProperty('--bg-card-transparent-overlay', t.cardTransparentOverlay || 'rgba(255,255,255,0.42)');
  root.style.setProperty('--bg-sidebar-transparent-overlay', t.sidebarTransparentOverlay || 'rgba(255,255,255,0.30)');
  root.style.setProperty('--bg-modal-transparent-overlay', t.modalTransparentOverlay || 'rgba(255,255,255,0.55)');
  root.style.setProperty('--bg-input-transparent-overlay', t.inputTransparentOverlay || 'rgba(255,255,255,0.45)');
  root.style.setProperty('--bg-footer-transparent-overlay', t.footerTransparentOverlay || 'rgba(255,255,255,0.25)');
  root.style.setProperty('--bg-connection-pill-transparent-overlay', t.connectionPillTransparentOverlay || 'rgba(255,255,255,0.35)');

  if (t.image) {
    document.body.style.backgroundImage = t.image;
    document.body.setAttribute('data-theme-image', '1');
  } else {
    document.body.style.backgroundImage = '';
    document.body.removeAttribute('data-theme-image');
  }
}

export function applyChatTransparency(enabled) {
  const root = document.documentElement;
  if (enabled) {
    root.setAttribute('data-chat-transparent', 'true');
  } else {
    root.removeAttribute('data-chat-transparent');
  }
}
